export default __webpack_public_path__ + "4b151f40b926ae5cefb3b300aa955fb5.png";